import type {
  ConversationAssignedEventData,
  ConversationCreatedEventData,
  ConversationPriorityChangedEventData,
  ConversationStatusChangedEventData,
  MessageReceivedEventData,
  MessageSentEventData,
  RulesTriggeredEventData,
  TagAddedEventData,
  TagRemovedEventData,
  ThreadCreatedEventData,
} from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event";
import type { ConversationTimelineEventResponse } from "@redotech/effect-api-shared/models/shopper-ai/conversation/timeline-event/timeline-event-response";
import { memo } from "react";
import { ConversationAssignedEvent } from "./events/conversation-assigned-event";
import { ConversationCreatedEvent } from "./events/conversation-created-event";
import { ConversationPriorityChangedEvent } from "./events/conversation-priority-changed-event";
import { ConversationReadEvent } from "./events/conversation-read-event";
import { ConversationStatusChangedEvent } from "./events/conversation-status-changed-event";
import { MessageReceivedEvent } from "./events/message-received-event";
import { MessageSentEvent } from "./events/message-sent-event";
import { RulesTriggeredEvent } from "./events/rules-triggered-event";
import { TagAddedEvent } from "./events/tag-added-event";
import { TagRemovedEvent } from "./events/tag-removed-event";
import { ThreadCreatedEvent } from "./events/thread-created-event";

export const TimelineEventCard = memo(function TimelineEventCard({
  event,
}: {
  event: ConversationTimelineEventResponse;
}) {
  switch (event.eventType) {
    case "conversation_created":
      return (
        <ConversationCreatedEvent
          data={event.eventData as ConversationCreatedEventData}
          event={event}
        />
      );
    case "conversation_status_changed":
      return (
        <ConversationStatusChangedEvent
          data={event.eventData as ConversationStatusChangedEventData}
          event={event}
        />
      );
    case "conversation_priority_changed":
      return (
        <ConversationPriorityChangedEvent
          data={event.eventData as ConversationPriorityChangedEventData}
          event={event}
        />
      );
    case "conversation_assigned":
      return (
        <ConversationAssignedEvent
          data={event.eventData as ConversationAssignedEventData}
          event={event}
        />
      );
    case "conversation_read":
      return <ConversationReadEvent event={event} />;
    case "message_sent":
      return (
        <MessageSentEvent
          data={event.eventData as MessageSentEventData}
          event={event}
        />
      );
    case "message_received":
      return (
        <MessageReceivedEvent
          data={event.eventData as MessageReceivedEventData}
          event={event}
        />
      );
    case "thread_created":
      return (
        <ThreadCreatedEvent
          data={event.eventData as ThreadCreatedEventData}
          event={event}
        />
      );
    case "tag_added":
      return (
        <TagAddedEvent
          data={event.eventData as TagAddedEventData}
          event={event}
        />
      );
    case "tag_removed":
      return (
        <TagRemovedEvent
          data={event.eventData as TagRemovedEventData}
          event={event}
        />
      );
    case "rules_triggered":
      return (
        <RulesTriggeredEvent
          data={event.eventData as RulesTriggeredEventData}
          event={event}
        />
      );
    default:
      return null;
  }
});
